import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MapPreviewOptions, Provider, Type } from './location-preview.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { LocationPreviewService } from './location-preview.service';
import * as L from 'leaflet';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { environment as env } from '../../../environments/environment';

@Component({
  selector: 'location-preview',
  templateUrl: './location-preview.component.html',
  styleUrls: ['./location-preview.component.scss']
})
export class LocationPreviewComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() options: MapPreviewOptions = {
    module: '',
    moduleUid: '',
    coords: [0,0],
    width: 0,
    height: 0,
    zoom: 0,
    provider: Provider.GOOGLE,
    type: Type.IFRAME,
    showNavigationIcon: false,
    address: ''
  };
  mapUrl: string;
  url: any;
  private map: any;
  private tileLayer: any;
  private mapTileUrl: string = window['mapTileUrl'];

  constructor(private _domSanitizer: DomSanitizer,
    private locationPreviewService: LocationPreviewService,
    private utilityService: UtilityService) {}

  ngOnInit(): void {
    this.getGoogleUrl();
    this.getSafeUrl();
  }

  ngAfterViewInit(): void {
    if(this.options.type === Type.LEAFLET){
     this.initMap();
    }
  }

  getSafeUrl(): void{
    if(this.options.type === Type.IFRAME){
      if(this.options.url){
        this.url = this._domSanitizer.bypassSecurityTrustResourceUrl(this.options.url);
      }
      else{
        if(this.options.provider === Provider.GOOGLE){
          this.url = this._domSanitizer.bypassSecurityTrustResourceUrl(this.locationPreviewService.getGoogleIframe(this.options));
        }
      }
    }
  }

  initMap(): void {
    const center = this.options.coords;
    const zoom = 15;
    this.map = L.map('map', {
      center : center,
      zoom : this.options.zoom??zoom,
      zoomControl : false,
      reuseTiles: true,
      unloadInvisibleTiles: true,
      attributionControl : false
    });
    this.map.dragging.disable();
    this.map.scrollWheelZoom.disable();

    L.control.zoom({position:'bottomright'}).addTo(this.map);
    this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    setTimeout(function(this) {
      window.dispatchEvent(new Event('resize'));
    }, 500);
    const icon = L.divIcon({
      className: 'custom-div-icon',
      html: '<img style="width:60%" src="assets/images/svgs/location_preview_map_pin.svg" alt="marker icon">',
      iconSize: [15, 27],
      iconAnchor: [10, 15]
    });
    //Creating marker and binding events
    const marker = L.marker(this.options.coords, {
        icon: icon
      }).addTo(this.map);
  }

  getFormattedAddress(address: any): string {
    return this.utilityService.getFormattedAddress(address);
  }

  getGoogleUrl(): void{
    if(this.options.provider === Provider.GOOGLE){
      this.mapUrl = this.locationPreviewService.getGoogleMap(this.options);
    }
    else{
      this.mapUrl = this.locationPreviewService.getHereMap(this.options);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('options' in changes){
      this.options = changes.options.currentValue;
      this.getGoogleUrl();
      this.getSafeUrl();
    }
  }
}
